export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/Time.9a844a0f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};